import { render, staticRenderFns } from "./RemoveStudentDialog.vue?vue&type=template&id=4f847af1&scoped=true&"
import script from "./RemoveStudentDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveStudentDialog.vue?vue&type=script&lang=js&"
import style0 from "./RemoveStudentDialog.vue?vue&type=style&index=0&id=4f847af1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f847af1",
  null
  
)

export default component.exports